module.exports = __webpack_public_path__ + "media/images/pic/gallery/2019/matsuri-piknik-z-kultura-japonii-d8d9694940df318e479d18139594ea2e.jpg";